import React, { useEffect, useState, MouseEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import Slider from 'react-slick';
import { debounce } from 'lodash';

import '../scss/vip-customer.scss';
import Color from '@/tool/color';
import moCustomer, { getList, changeList } from '../store/vip-customer';
import CopyIcon from '@icon/copy-11.png';

interface IProps {}
interface IState {}

const VipCustomer = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();
  const { list } = moCustomer;
  const [showLength, setShowLength] = useState(2);
  const [scrollLength, setScrollLength] = useState(2);
  const [cusWidth, setCusWidth] = useState('1280px');

  const onResize = () => {
    const width = document.body.clientWidth || document.documentElement.clientWidth;
    if (width >= 1890) {
      setCusWidth('1890px');
      setShowLength(3);
      setScrollLength(3);
      changeList(true);
    } else {
      setCusWidth('1280px');
      setShowLength(2);
      setScrollLength(2);
      changeList(false);
    }
  };

  useEffect(() => {
    getList();
    onResize();
    window.addEventListener('resize', debounce(onResize, 200));

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <section className="vip-customer"
      style={{ width: cusWidth }}>
      <Slider {...{
        dots: true,
        infinite: true,
        autoplaySpeed: 5000,
        speed: 500,
        arrows: false,
        autoplay: true,
        slidesToShow: showLength,
        slidesToScroll: scrollLength,
      }}>
        {list && list.map((item, index) => (
          <section className="slick-section" key={index}>
            <section className="slick-box">
              <img src={CopyIcon} alt="icon" className="copy-11" />
              <span className="text-61">{item.content}</span>
              <section className="right-60">
                <p className="circle-60">
                  <img src={item.logoSrc} alt="logo" />
                </p>
                <span className="span-60">{item.name}</span>
              </section>
            </section>
          </section>
        ))}
      </Slider>
    </section>
  );
};

export default observer(VipCustomer);
